import React from 'react'
import HeaderLogin from '../components/headerLogin/headerLogin'
import Login from '../components/login/login'
import { useTranslation } from "react-i18next"

export default function LoginPage() {
    const { t, i18n } = useTranslation()

    return (
        <>
            {/* <HeaderLogin i18n={i18n} t={t} /> */}
            <Login t={t} />
        </>
    )
}